import { render, staticRenderFns } from "./datatable-sort.vue?vue&type=template&id=52aff95c&scoped=true&"
import script from "./datatable-sort.vue?vue&type=script&lang=ts&"
export * from "./datatable-sort.vue?vue&type=script&lang=ts&"
import style0 from "./datatable-sort.vue?vue&type=style&index=0&id=52aff95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aff95c",
  null
  
)

export default component.exports